import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function CustomPortal({ children }) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;

  return createPortal(children, document.body);
}
